import callApi from '../../util/apiCaller';

export function loadOwner(ownerId) {
  const p = new Promise((resolve, reject) => {
    callApi(`owners/${ownerId}`, 'GET').then(
      (results) => {
        resolve(results);
      },
      (error) => {
        reject(error);
      },
    );
  });
  return p;
}